import DeliveryPoint from '@/dto/deliveries/DeliveryPoint'

export default function DeliveryPointFactory({
  cityId,
  deliveryId,
}: {
  cityId: number
  deliveryId: number
}): DeliveryPoint {
  return {
    id: null,
    cityId,
    deliveryId,
    enabled: true,
    cardEnabled: true,
    codEnabled: true,
    address: '',
    courierCode: '',
    description: '',
    lat: '',
    lon: '',
    phones: '',
    schedule: '',
  }
}
